import { gridFilteredSortedRowIdsSelector } from '@mui/x-data-grid-premium';

// "params" has to be the Data Grid columns params object
export const getGroupedRowData = (params) => {
  const rowIds = params?.api?.getRowGroupChildren({
    groupId: params?.id,
  });
  return params?.api?.getRow(rowIds[0]);
};

export const getIsGroupingEnabled = (params) => {
  return params?.api?.state?.rowGrouping?.model?.length > 0;
};

// apiRef - this is MUI Data Grid api object
export const gridFilteredSortedRowIdsWithoutGroupsIdsCustomSelector = (
  apiRef,
) => {
  return gridFilteredSortedRowIdsSelector(apiRef).filter(
    (rowId) => !rowId.includes('auto-generated-row'),
  );
};

export const getGridActiveColumnsForExport = (apiRef) => {
  const allColumns = apiRef.current?.state?.columns?.all;
  const columnsVisibility =
    apiRef.current?.state?.columns?.columnVisibilityModel;

  return allColumns.filter((columnName) => {
    // skip auto generated columns map
    if (columnName.startsWith('__')) {
      return false;
    }
    if (
      Object.keys(columnsVisibility)?.includes(columnName) &&
      !columnsVisibility[columnName]
    ) {
      return false;
    }
    return columnName;
  });
};

export const handleExportAsCSV = ({ options = {}, apiRef, exportFileName }) => {
  const exportOptions = exportFileName
    ? {
      ...options,
      fileName: exportFileName,
    }
    : options;

  return apiRef.current.exportDataAsCsv(exportOptions);
};

export const booleanYesAndNoFilterOperators = [
  {
    label: 'Yes',
    value: 'is',
    getApplyFilterFn: (filterItem) => (params) => params.value,
  },
  {
    label: 'No',
    value: 'isNot',
    getApplyFilterFn: (filterItem) => (params) => !params.value,
  },
];
